import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, CardBody } from "shards-react";
import { httpsCallable } from "firebase/functions";
import { collection, onSnapshot } from "firebase/firestore";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import swal from "sweetalert";

import { db, firebaseFunctions } from "../../firebase";
import "../pagination.css";
import "../admin/userDetails/tab.css";
import { checkDateForColorView, getDaysAgo } from "../../utils/common_handlers";

const Users = () => {
  const [Users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState(Users);
  const [filterText, setFilterText] = useState("");
  const [loading, setLoading] = useState(false);
  const [deletingUserId, setDeletingUserId] = useState("");
  const [deletingUser, setDeletingUser] = useState(false);
  const UsersRef = React.useRef(Users);

  useEffect(() => {
    setLoading(true);
    const unsubscribe = onSnapshot(collection(db, "DeletedUserData"), data => {
      data.docChanges().forEach(async change => {
        if (change.type === "added") {
          setUsers(prevUsers => [
            ...prevUsers,
            { uid: change.doc.id, ...change.doc.data() }
          ]);
        }
        if (change.type === "modified") {
          let newArray = [...UsersRef.current];
          let index = newArray.findIndex(user => change.doc.id === user.uid);
          newArray[index] = { uid: change.doc.id, ...change.doc.data() };
          setUsers(newArray);
        }
        if (change.type === "removed") {
          let newArray = [...UsersRef.current];
          let index = newArray.findIndex(user => change.doc.id === user.uid);
          newArray.splice(index, 1);
          setUsers(newArray);
        }
      });
    });
    setLoading(false);
    return unsubscribe;
  }, []);

  useEffect(() => {
    UsersRef.current = Users;
    setFilteredUsers(Users);
  }, [Users]);

  const columns = [
    {
      dataField: "FirstName",
      text: "Full Name",
      sort: true,
      formatter: (cell, row) => {
        return <>{row.FirstName}</>;
      }
    },
    {
      dataField: "Email",
      sort: true,
      text: "Email",
      formatter: (cell, row) => {
        return <>{cell}</>;
      }
    },
    {
      dataField: "ValidTill",
      text: "Valid Till",
      sort: true,
      formatter: (cell, row) => {
        return <>{cell ? cell.toDate().toDateString() : "-"}</>;
      }
    },
    {
      dataField: "LastSessionDoneAt",
      text: "Time Since the Last Session",
      sort: true,
      formatter: (cell, row) => {
        return (
          <span
            style={{
              color: checkDateForColorView(
                row.LastSessionDoneAt &&
                  row.LastSessionDoneAt.toDate().toDateString()
              )
            }}
          >
            {row.LastSessionDoneAt &&
              getDaysAgo(row.LastSessionDoneAt.toDate().toDateString())
            // moment(
            //   row.LastSessionDoneAt.toDate().toString()
            // ).fromNow()
            }
          </span>
        );
      }
    },
    {
      isDummyField: true,
      dataField: "",
      text: "Action",
      formatter: (cell, row) => {
        return (
          <div style={{ display: "flex", gap: "4px" }}>
            <button
              type="button"
              className="btn btn-info"
              style={{ zIndex: 1 }}
              onClick={() => restoreUser(row.uid)}
            >
              Restore User
            </button>
            <button
              type="button"
              disabled={deletingUser && deletingUserId === row.uid}
              className="btn btn-danger"
              style={{ zIndex: 1 }}
              onClick={() => {
                deleteUserPermanently(row.uid);
              }}
            >
              Permenent Delete
            </button>
          </div>
        );
      }
    }
    // {
    //   isDummyField: true,
    //   dataField: 'delete',
    //   text: 'Delete',
    //   formatter: (cell, row) => {
    //     return (

    //     )
    //   }
    // },
  ];

  const pagination = paginationFactory({
    sizePerPage: 50,
    hideSizePerPage: true
  });

  const deleteUserPermanently = async uid => {
    swal({
      title: "Are you sure?",
      text: "Once Deleted, you won't be able to retrieve the data",
      icon: "error",
      buttons: true,
      dangerMode: true
    }).then(async willDelete => {
      if (willDelete) {
        try {
          if (uid !== "") {
            setDeletingUserId(uid);
            setDeletingUser(true);
            swal({
              title: "Deleting",
              text: "Deleting user data",
              icon: "info"
            });
            const functionCall = httpsCallable(
              firebaseFunctions,
              "userDeletion-completeDelete"
            );
            const response = await functionCall({
              uid: uid
            });
            swal.close();
            if (response.data.success) {
              swal({
                title: "Success!",
                text: "User deleted",
                icon: "success"
              });
            } else {
              swal({
                title: "Error!",
                text: response.data.errorInfo
                  ? response.data.errorInfo.message
                  : "Some error occured",
                icon: "error"
              });
            }
            setDeletingUserId("");
            setDeletingUser(false);
          } else {
            swal({
              title: "Warning!",
              text: "Please provide id",
              icon: "warning"
            });
          }
        } catch (error) {
          swal({
            title: "Error!",
            text: error.message,
            icon: "error"
          });
          setDeletingUserId("");
          setDeletingUser(false);
        }
      }
    });
  };

  useEffect(() => {
    if (filterText.length > 0) {
      setFilteredUsers(
        Users.filter(obj =>
          JSON.stringify(obj)
            .toLowerCase()
            .includes(filterText.toLowerCase())
        )
      );
    } else {
      setFilteredUsers(Users);
    }
  }, [Users, filterText]);

  const searchBar = () => {
    return (
      <input
        className="form-control"
        type="text"
        value={filterText}
        onChange={e => {
          setFilterText(e.target.value);
        }}
      />
    );
  };

  const restoreUser = () => {
    swal({
      title: "Info!",
      text: "This feature will be avialable soon.",
      icon: "warning"
    });
  };

  return (
    <Container fluid className="main-content-container px-4">
      {loading ? (
        <div className="wrapper">
          <div className="spinner">
            <div className="spinner-1"></div>
            <div className="spinner-2"></div>
            <div className="spinner-3"></div>
          </div>
        </div>
      ) : (
        <Row className="page-header py-4">
          <Col>
            <Card small className="mb-4">
              <CardBody className="p-0 pb-3">
                <ToolkitProvider
                  keyField="uid"
                  data={filteredUsers}
                  columns={columns}
                  bootstrap4
                  search
                >
                  {props => (
                    <div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "15px 20px"
                        }}
                      >
                        <h6 className="m-0 font-weight-bold">Deleted Users</h6>
                        <div className="w-45">{searchBar()}</div>
                      </div>
                      <BootstrapTable
                        pagination={pagination}
                        defaultSorted={[
                          {
                            dataField: "LastSessionDoneAt",
                            order: "desc" // or desc
                          }
                        ]}
                        {...props.baseProps}
                      />
                    </div>
                  )}
                </ToolkitProvider>
                {/* <BootstrapTable keyField='uid' data={Users} columns={columns} pagination={pagination} rowEvents={rowEvents} bootstrap4 /> */}
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default Users;
